import occupied_flag from "../../../Assets/Flags/occupied_flag.svg";
import {
  Container,
  Flag,
  Guest,
  State,
  StateContainer,
  TotalCost,
} from "./style";
import { ICardHUProps } from "../../../Interfaces";

import { formatter } from "../../../Utils";
import { useHabUnits } from "../../../Providers/HabUnit";

interface IOccupiedInfos {
  isReserved: boolean;
}

const OccupiedInfos = ({
  data,
  isReserved,
}: ICardHUProps & IOccupiedInfos) => {
  const { state } = data;
  const { getTotal } = useHabUnits();

  // listHUs(userID);
  const total = getTotal(data);

  return (
    <div>
      <Container>
        <StateContainer>
          <Flag src={occupied_flag} />
          <State state={state} isReserved={isReserved}>
            ocupado
          </State>
        </StateContainer>
        <Guest>{data.guests && data.guests[0].name}</Guest>
        <TotalCost>Total: {formatter.format(total)}</TotalCost>
      </Container>
    </div>
  );
};
export default OccupiedInfos;
